class TimeEntry {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.timeEntryId = data.timeEntryId || `TIME${Date.now()}`;
      this.userId = data.userId || null;
      this.projectId = data.projectId || null;
      this.taskId = data.taskId || null;
      this.description = data.description || '';
      this.startTime = data.startTime || null;
      this.endTime = data.endTime || null;
      this.duration = data.duration || 0;
      this.date = data.date || new Date().toISOString().split('T')[0];
      this.billable = data.billable !== undefined ? data.billable : true;
      this.hourlyRate = data.hourlyRate || 0;
      this.status = data.status || 'Draft';
      this.notes = data.notes || '';
      this.createdAt = data.createdAt || new Date().toISOString();
      this.updatedAt = data.updatedAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = {
        'Draft': '#6b7280',
        'Submitted': '#3b82f6',
        'Approved': '#10b981',
        'Rejected': '#ef4444'
      };
      return colors[this.status] || '#6b7280';
    }
  
    calculateDuration() {
      if (this.startTime && this.endTime) {
        const start = new Date(`1970-01-01T${this.startTime}`);
        const end = new Date(`1970-01-01T${this.endTime}`);
        const diff = (end - start) / (1000 * 60);
        return Math.max(0, diff);
      }
      return this.duration || 0;
    }
  
    getDurationFormatted() {
      const minutes = this.calculateDuration();
      const hours = Math.floor(minutes / 60);
      const mins = Math.round(minutes % 60);
      return `${hours}h ${mins}m`;
    }
  
    calculateAmount() {
      if (!this.billable || !this.hourlyRate) return 0;
      const hours = this.calculateDuration() / 60;
      return hours * this.hourlyRate;
    }
  
    validate() {
      const errors = [];
      if (!this.userId) errors.push('User is required');
      if (!this.projectId) errors.push('Project is required');
      if (!this.date) errors.push('Date is required');
      if (!this.startTime && !this.duration) errors.push('Start time or duration is required');
      
      if (this.startTime && this.endTime) {
        const duration = this.calculateDuration();
        if (duration <= 0) errors.push('End time must be after start time');
      }
      
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() {
      return {
        id: this.id,
        _id: this._id,
        timeEntryId: this.timeEntryId,
        userId: this.userId,
        projectId: this.projectId,
        taskId: this.taskId,
        description: this.description,
        startTime: this.startTime,
        endTime: this.endTime,
        duration: this.calculateDuration(),
        date: this.date,
        billable: this.billable,
        hourlyRate: this.hourlyRate,
        status: this.status,
        notes: this.notes,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      };
    }
  
    static fromJSON(json) {
      return new TimeEntry(json);
    }
  }
  
  export default TimeEntry;